import ApiBase from './ApiBase';
import axios from 'axios';

class UserActivityApi extends ApiBase {
  /**
   * add user note activity
   * @param {*} note
   */
  async add(note) {
    const request = {
      url: `${this.API_URL}/activity/note`,
      headers: this.getHeaders(),
      method: 'PUT',
      data: JSON.stringify(note)
    };

    const response = await axios.request(request);

    return response.data;
  }
}
export default new UserActivityApi();
